import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=3073b0fc&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=3073b0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3073b0fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSheetItem: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseSheetItem.vue').default})
